import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isToday,
  isSameMonth,
  isSameDay,
  eachDayOfInterval,
} from "date-fns";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEventImage,
  fetchScheduleCategory,
  fetchSpecificEvent,
  resetCreateEvent,
  updateEvent,
} from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";

const EventRap = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 30px;
  .events h4 {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    padding: 15px;
    padding-bottom: 25px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    max-width: 430px;
    border-radius: 15px;
  }
  .all-events h2 {
    color: #060b13;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  /* .events p {
    padding: 15px;
    border-radius: 100px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    width: 430px;
    margin-bottom: 20px;
  } */
/* .event-links {
  display: flex;
  align-items: center;
  border-radius: 100px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    width: 430px;
  padding: 15px;
  gap: 5px;
  overflow: hidden; 
} */

/* .event-links p {
  color: #363d4f;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
} */

.event-links {
  display: flex;
  background: #060b130a;
   border-radius: 100px;
    border: 1px solid #bac0d499;
  background: #060b130a;
    padding: 15px;
    border: 1px solid #bac0d499;
  align-items: center;
  gap: 8px;
    width: 430px;
  padding: 10px;
}
.event-linker {
  display: flex;
  align-items: center;
  gap: 8px;
}
.label {
  color: #363d4f;
  font-weight: 400;
  font-size: 14px;
  white-space: nowrap;
}

.scroll-container {
  overflow: hidden;
  width: 300px; /* adjust width as needed */
  white-space: nowrap;
  position: relative;
}

.scrolling-text {
  display: inline-block;
  padding-left: 100%;
  color: #ed1c24;
  animation: scroll-text 30s linear infinite;
}

@keyframes scroll-text {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}

  /* .event-links {
    display: flex;
    align-items: center;
    gap: 5px;

  } */
  .event-links-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid #bac0d499;
    border-radius: 50%;
  }
  .event-links-sent {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .delete-button,
  .edit-button,
  .stream-button {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-radius: 100px;
    background: #ffffff;
    padding: 12px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-style: solid;
    color: #060b13;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    border-color: #060b13;
  }
  .edit-button,
  .stream-button {
    background: #ed1c24;
    color: #ffffff;
  }
  .event-buttons {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
  }
  .all-events {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  .events {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }
  .event-image-div {
    width: 80%;
    min-height: 460px;
    border-radius: 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .event-sub {
    width: fit-content;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

 

  .event-sub {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .timezone p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .timezone p a {
    text-decoration: none;
    color: #ed1c24;
  }
  .timezone {
    position: relative;
  }
  .timezone-dropdown {
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 15px;
    width: 300px;
    background: #ffffff;
    position: absolute;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .time-input,
  .calendar-container input {
    width: 210px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    border: 0.8px solid #bac0d4b2;

    font-weight: 400;
    font-size: 12px;
  }
  .time-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 207px;
    background: #ffffff;
    padding: 20px;
    margin-top: 10px;
    padding-right: 10px;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
  }
  .time-dropdown p {
    color: #060b13;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }
  .time-dropdown-div {
    max-height: 240px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
  .time-dropdown-div::-webkit-scrollbar {
    width: 6px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .time-dropdown-div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .time-dropdown-div::-webkit-scrollbar-button {
    display: none;
  }
  .the-time {
    padding: 10px;
    cursor: pointer;
    border-radius: 6px;
    color: #060b13;
    font-weight: 500;
    font-size: 12px;
  }
  .time-cancel {
    border: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    background: #ffffff;
  }
  .time-save {
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
    width: 66px;
    height: 32px;
    border-radius: 8px;
  }
  .calendar-container {
    position: relative;
    max-width: 344px;
  }

  .calendar-dropdown {
    position: absolute;
    top: 50px;
      right: 20%;
    background: white;
    border: 0.6px solid #d0d5dd;
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 344px;
    z-index: 10;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
    color: #1e1e1c;
    font-size: 14px;
    font-weight: 400;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .calendar-day {
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #1e1e1c;
    font-weight: 400;
  }

  .today {
    color: #ed1c24;
  }

  .selected {
    background: #ed1c24;
    color: white;
    border-radius: 50%;
  }

  .other-month {
    color: #828280;
  }
  .start-date-time {
    display: flex;
    gap: 10px;
  }
  .category-input {
    width: 430px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
  }
  .category-input p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 0px 15px;
  }
  .category {
    position: relative;
  }
  .category-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    background: #ffffff;
    width: 430px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 15px;
    padding: 10px;
    z-index: 9999;
    position: absolute;
    margin-top: 10px;
  }
  .category-dropdown p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
  }
  .category-dropdown p:hover {
    background: #e8e9eb;
    border-radius: 6px;
  }
  input, textarea {
    border: 0.8px solid #bac0d4b2;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding-left: 15px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-dropdown-div {
    max-width: 500px;
    max-height: 546px;
    background: #ffffff;
    border-radius: 16px;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }
 
  .delete-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 500px;
    height: 276px;
  }
  .delete-div p {
    color: #828286;
    max-width: 257px;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    font-weight: 400;
  }
  .delete-div h4 {
    color: #060b13;
    font-size: 18px;
    font-weight: 500;
  }
  .move-back-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.7px solid #828286;
  }
  .events-head {
    display: flex;
   
    gap: 10px;
  }

   @media (max-width: 1024px) {
    .event-buttons {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  @media (max-width: 768px) {
    padding: 20px;

    .events h4 {
      max-width: 100% !important;
    }
 .event-image-div {
    width: 100%;
  }
    .event-links,
    .category-input,
    input,
    textarea,
    .schedule-btn {
      width: 100% !important;
    }
 
    .start-date-time,
    .event-buttons,
    .event-links-sent {
      flex-direction: column;
      align-items: stretch;
    }
  }

  @media (max-width: 480px) {
    .event-links {
      padding: 12px;
    }
.event-links {
  width: 350px !important;
 }
    .event-buttons button {
      width: 100%;
      justify-content: center;
    }
  }

   @media (max-width: 400px) {
   
.event-links {
  width: 300px !important;
 }

}
   @media (max-width: 350px) {
   
.event-links {
  width: 260px !important;
 }

}
`;

const EventsDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { sheduleCategory, specificEvent, eventSuccess, userChannel, userEvents, eventloading, userData, loading, error, eventImages } =
    useSelector((state) => state.userData);

          const channelId = specificEvent?.data?.channelId; 

    const navigate = useNavigate()
 
 



  console.log(specificEvent);
  










  useEffect(() => {
    if (id && !eventImages?.[id]) {
      dispatch(fetchEventImage(id));
    }
  }, [dispatch, id, eventImages]);

  const defaultEventImage = "/images/image_1.png";
  const eventBackgroundImage = eventImages?.[id] ?? defaultEventImage;

  const eventHeroBackground = useMemo(
    () =>
      `linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 20.95%,
        rgba(0, 0, 0, 0.659617) 81.51%,
        #000000 103.25%
      ), url('${eventBackgroundImage}')`,
    [eventBackgroundImage]
  );









useEffect(() => {
    if (id) {
      dispatch(fetchSpecificEvent(id));
    }
  }, [dispatch, id]);

  const handleGoToDetails = () => {
    navigate("/listener/events")
  }

  const handleStartStreaming = () => {
    if (!channelId) {
      toast.error("Channel information not found. Please create a channel first.");
      return;
    }

    if (!id) {
      toast.error("Event information is incomplete.");
      return;
    }

    navigate(`/listener/live/${channelId}/${id}`);
  };

  
  
  return (
    <EventRap>
      <div className="all-events">
        <div>
          <div className="events-head">
            <div onClick={handleGoToDetails} className="move-back-icon">
              <Icon
                icon="iconamoon:arrow-left-2-light"
                width="18"
                height="18"
                style={{ color: "#363D4F", cursor: "pointer" }}
              />
            </div>
            <h2>Events</h2>
          </div>

          <div className="events">
            <div className="event-image-div" style={{ backgroundImage: eventHeroBackground }}></div>
            <div className="event-sub">
              <p>{specificEvent?.data?.category}</p>
              <h4>
                {specificEvent?.data?.description}{" "}
              </h4>
              <div className="event-links-sent">
<div className="event-links">
  <p className="label">Event link:</p>
  <div className="scroll-container">
    <span className="scrolling-text">
      {specificEvent?.data?.audioUrl}
    </span>
  </div>
</div>
<div className="event-linker">

                <div className="event-links-icon">
                  <Icon
                    icon="basil:facebook-solid"
                    width="16"
                    height="16"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                </div>
                <div className="event-links-icon">
                  <Icon
                    icon="ri:linkedin-fill"
                    width="16"
                    height="16"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                </div>
                <div className="event-links-icon">
                  <Icon
                    icon="mdi:twitter"
                    width="16"
                    height="16"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                </div>
            </div>
              </div>
              <div className="event-buttons">
                <button
                  onClick={handleStartStreaming}
                  className="stream-button"
                >
                  <Icon
                    icon="mdi:radio"
                    width="18"
                    height="18"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                  Join streaming
                </button>
               
                
              </div>
            </div>
          </div>
        </div>
      </div>
      
    
       
    </EventRap>
  );
};

export default EventsDetails;
